import BaseController from "confinus_ui/base_controller";
import flatpickr from "flatpickr";
import { Instance } from "flatpickr/dist/types/instance";

export default class MetricFiltersController extends BaseController {
  static targets = [
    "form",
    "startDate",
    "endDate",
    "dateRangeInput",
    "periodSelect",
  ];

  declare readonly formTarget: HTMLFormElement;
  declare readonly startDateTarget: HTMLInputElement;
  declare readonly endDateTarget: HTMLInputElement;
  declare readonly dateRangeInputTarget: HTMLInputElement;
  declare readonly periodSelectTarget: HTMLSelectElement;
  declare readonly hasStartDateTarget: boolean;
  declare readonly hasEndDateTarget: boolean;
  declare readonly hasDateRangeInputTarget: boolean;
  declare readonly hasPeriodSelectTarget: boolean;

  private datePicker?: flatpickr.Instance;

  connect(): void {
    // noop - flatpickr is initialized on demand via openDateRangePicker
  }

  disconnect(): void {
    if (this.datePicker) {
      this.datePicker.destroy();
    }
  }

  // Auto-submit when period or bucket changes
  filterChanged(event: Event): void {
    // If period is being changed to a preset, clear custom date range
    const target = event.target as HTMLSelectElement;
    if (target.name === "period" && target.value !== "custom") {
      if (this.hasStartDateTarget) this.startDateTarget.value = "";
      if (this.hasEndDateTarget) this.endDateTarget.value = "";
    }

    this.submitForm();
  }

  // Open date range picker
  openDateRangePicker(event: Event): void {
    event.preventDefault();

    if (!this.hasDateRangeInputTarget) return;

    // Initialize flatpickr with range mode
    this.datePicker = flatpickr(this.dateRangeInputTarget, {
      mode: "range",
      dateFormat: "Y-m-d",
      maxDate: "today",
      onClose: (selectedDates: Date[], dateStr: string, instance: Instance) => {
        if (selectedDates.length === 2) {
          // Format dates
          const startDate = instance.formatDate(selectedDates[0], "Y-m-d");
          const endDate = instance.formatDate(selectedDates[1], "Y-m-d");

          // Set hidden fields
          if (this.hasStartDateTarget) this.startDateTarget.value = startDate;
          if (this.hasEndDateTarget) this.endDateTarget.value = endDate;

          // Update display
          this.dateRangeInputTarget.value = `${startDate} to ${endDate}`;

          // Set period to custom
          if (this.hasPeriodSelectTarget) {
            this.periodSelectTarget.value = "custom";
          }

          // Submit form
          this.submitForm();
        }
      },
    });

    this.datePicker.open();
  }

  // Submit the form via Turbo
  private submitForm(): void {
    this.formTarget.requestSubmit();
  }
}
